








import { Box, Flex, Button } from '../../atoms'
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {
    Box,
    Flex,
    Button
  }
})
export default class BackBox extends Vue {
  backToHomePage() {
    const baseURL = process.env.VUE_APP_FINNO_ENDPOINT || ''
    location.href = baseURL
  }
}
